module.exports = __webpack_public_path__ + "static/media/headerAyasa.21e4c769.png";